class ResendInvitation {
	constructor(
		public readonly accountId: number,
		public readonly userId: number,
	) {
		Object.freeze(this);
	}
}

export default ResendInvitation;
